/*行业直播接口*/
import axios from "../index";
import api from "./Authority.api";

export default {
    /**
     *项目是否在国匠云授权
     */
    authorityAbout() {
        return axios.post(api.authorityAbout, );
    },
  
    /**
     *项目是否校验注册码和授权码
     */
    authorityIsGrant() {
        return axios.post(api.authorityIsGrant);
    },
  
    /**
     *校验注册码和授权码
     */
    authorityRegister(data = {}) {
        return axios.post(api.authorityRegister, data);
    },
  
}